export default {
  periods: 45,
  refs: [
    "xChart",
    "generalChart",
    "notLocatedPieChart",
    "locatedChannelsPieChart",
    "locatedCreditorPieChart",
    "locatedActuationBarChart",
    "notLocatedCreditorPieChart",
    "notLocatedChannelsPieChart",
    "notLocatedActuationBarChart",
    "locatedValidChannelsPieChart",
    "notLocatedValidChannelsPieChart",
    "notLocatedVariablesBarChart",
    "locatedVariablesBarChart"
  ],
}